import { withRouter } from 'react-router';
import ConfirmationPage from './confirmation';

export default withRouter(ConfirmationPage);
